const WarrantsInsights = () => import(/* webpackChunkName: "warrants" */ '@/pages/warrants/insights'); // MAY NEED TO CHANGE LATER
const WarrantManage = () => import(/* webpackChunkName: "warrants" */ '@/pages/warrantManage');
const WarrantHolders = () => import(/* webpackChunkName: "warrants" */ '@/pages/warrantHolders');
export default [
  {
    path: 'warrants/holders',
    name: 'Warrants  /  Holders',
    component: WarrantHolders,
  },
  {
    path: 'warrants/insights',
    name: 'Warrants / Insights',
    component: WarrantsInsights,
  },
  {
    path: 'warrants/manage:warrant_id?',
    name: 'Warrants / Manage',
    component: WarrantManage,
  },
];
